import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';

import { RegionRow_region$key } from '__generated__/RegionRow_region.graphql';

type Props = EntityTableRowProps & {
  region: RegionRow_region$key;
  onDelete: (id: string) => void;
};

const RegionRow: FC<Props> = ({ region, ...props }) => {
  const regionData = useFragment(
    graphql`
      fragment RegionRow_region on Region {
        id
        name

        ...EntityTableRow_entity
      }
    `,
    region
  );

  const { id, name } = regionData;

  return (
    <EntityTableRow entity={regionData} {...props}>
      <TableCell>
        <Link href={`/settings/regions/${id}`}>{name}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default RegionRow;
